import { AlertTriangle, CheckCircle2, CircleDot, Clock3, PauseCircle } from "lucide-react";

import type { TicketPriority, TicketStatus } from "../lib/types";

const STATUS_LABELS: Record<TicketStatus, string> = {
  new: "New",
  open: "Open",
  pending: "Waiting on customer",
  on_hold: "On hold",
  solved: "Solved",
  closed: "Closed",
};

export function StatusBadge({ status }: { status: TicketStatus }) {
  const Icon = status === "solved" || status === "closed"
    ? CheckCircle2
    : status === "pending"
      ? Clock3
      : status === "on_hold"
        ? PauseCircle
        : CircleDot;
  return (
    <span className={`badge badge--status badge--${status}`}>
      <Icon aria-hidden="true" size={13} />
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  return (
    <span className={`badge badge--priority badge--priority-${priority}`}>
      {priority === "urgent" && <AlertTriangle aria-hidden="true" size={13} />}
      {priority[0].toUpperCase() + priority.slice(1)}
    </span>
  );
}

